import type { StatusVariant } from '@factorialco/f0-react'
import type { FormsFormStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export function formStatusMapper(status: FormsFormStatusEnum): {
  label: string
  status: StatusVariant
} {
  switch (status) {
    case 'draft':
      return { label: i18n.t('surveys.status.draft'), status: 'warning' }
    case 'scheduled':
      return { label: i18n.t('surveys.status.scheduled'), status: 'info' }
    case 'active':
      return { label: i18n.t('surveys.status.active'), status: 'positive' }
    case 'finished':
      return { label: i18n.t('surveys.status.finished'), status: 'neutral' }
    case 'archived':
      return { label: i18n.t('surveys.status.archived'), status: 'neutral' }
    default:
      return status satisfies never
  }
}
